// src/hooks/useAuth.ts
import { useState, useEffect } from 'react';
// Let op de toevoeging van 'User' aan het einde van deze import!
import { onAuthStateChanged, signInWithPopup, signOut, setPersistence, browserLocalPersistence, User } from 'firebase/auth';
import { auth, googleProvider, firebaseInitialized } from '../constants/firebase';

export const useAuth = () => {
  // Hier vertellen we TypeScript: "user kan een Firebase User zijn, óf null"
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => { 
        if (!firebaseInitialized) { setLoading(false); return; } 
        try {
            if (auth) { await setPersistence(auth, browserLocalPersistence); }
        } catch (e) { console.warn("Kon auth persistence niet instellen", e); }
    };
    initAuth();

    if (firebaseInitialized && auth) {
        const unsubscribe = onAuthStateChanged(auth, (u) => { setUser(u); setLoading(false); });
        return () => unsubscribe();
    } else { 
        setLoading(false); 
    }
  }, []);

  const handleGoogleLogin = async () => {
      if (!firebaseInitialized) return;
      try { await signInWithPopup(auth, googleProvider); } 
      catch (error: any) { 
          console.error("Login failed:", error); 
          if (error.code === 'auth/unauthorized-domain') {
              alert("Let op: Domein niet op 'Authorized Domains' lijst in Firebase.");
          } else { alert("Inloggen mislukt: " + error.message); }
      }
  };

  const logout = async () => {
      if (window.confirm("Weet je zeker dat je wilt uitloggen?")) { 
          await signOut(auth); 
      }
  };

  return { user, loading, handleGoogleLogin, logout };
};